import { Center, GridItem, Image, useRadio } from '@chakra-ui/react';
import { getColorValue } from '@shinetools/sunshine';

import {
  BANK_ACCOUNT_ILLUSTRATIONS,
  BankAccountIllustrationsType,
} from 'components/BankAccountIcon/constants';

interface IllustrationRadioCardProps {
  value: string;
}

const IllustrationRadioCard = (props: IllustrationRadioCardProps) => {
  const { getInputProps, getRadioProps } = useRadio(props);

  const input = getInputProps();
  const checkbox = getRadioProps();

  return (
    <GridItem as="label">
      <input {...input} />
      <Center
        gap={6}
        {...checkbox}
        _checked={{
          boxShadow: `inset 0px 0px 0px 1.5px ${getColorValue('grey.800')}`,
        }}
        backgroundColor="grey.200"
        borderRadius="radius-16"
        cursor="pointer"
        height="height-64"
        py="space-16"
      >
        <Image
          alt={props.value}
          fit="fill"
          role="presentation"
          src={
            BANK_ACCOUNT_ILLUSTRATIONS[
              props.value as keyof BankAccountIllustrationsType
            ]
          }
          width={80}
        />
      </Center>
    </GridItem>
  );
};

export default IllustrationRadioCard;
